export interface Project {
  id: string;
  title: string;
  date: string;
  description: string;
  overview: string;
  programDetails: {
    duration: string;
    spots: {
      total: number;
      available: number;
    };
    dates: string;
    stipend: string;
    facilities: string[];
    requirements: string[];
  };
  details: {
    title: string;
    content: string;
  }[];
  coverImage?: string;
  gallery?: string[];
}

export const projects: Project[] = [
  {
    id: 'artist-residency-2025',
    title: 'Artist Residency Program',
    date: 'March 2025',
    description: 'Our first artist residency program at Deja Home, providing artists with accommodation, workspace, and creative funding.',
    overview: 'Selected artists will have the opportunity to immerse themselves in their creative process with full support from Deja. This residency program aims to foster artistic innovation and cultural exchange in the vibrant creative environment of Chiang Mai.',
    programDetails: {
      duration: '2-4 weeks per artist',
      spots: {
        total: 4,
        available: 3
      },
      dates: 'March 2025',
      stipend: 'Up to 50,000 THB creative grant + 50/50 revenue share from artwork sales',
      facilities: [
        'Private bedroom in Deja Home',
        'Shared kitchen and living spaces',
        'Access to Deja Warehouse creative space',
        'Basic art supplies and materials',
        'High-speed internet access',
        'Bicycle for local transportation'
      ],
      requirements: [
        'Portfolio of previous work',
        'Project proposal for the residency period',
        'Commitment to participate in community events',
        'Willingness to share work process and final pieces',
        'Valid visa for Thailand'
      ]
    },
    details: [
      {
        title: 'Accommodation',
        content: 'Artists will be provided with comfortable living space at Deja Home free of charge, allowing them to fully focus on their creative work.'
      },
      {
        title: 'Creative Space',
        content: 'Access to Deja Warehouse, a dedicated space for artistic creation and experimentation, equipped with essential facilities.'
      },
      {
        title: 'Financial Support',
        content: 'A creative grant of 10,000 - 50,000 THB will be provided to support the artist\'s materials and production costs. Revenue from artwork sales during the residency will be shared 50/50 between the artist and Deja.'
      },
      {
        title: 'Location',
        content: 'The residency is located in Chiang Mai, Thailand. You can find us on Google Maps for directions and visit.'
      }
    ],
    coverImage: '/images/warehouse.jpg',
    gallery: [
      '/images/airbnb/Living-Area.jpg',
      '/images/airbnb/Garden.jpg',
      '/images/airbnb/Bedroom_1.jpg',
      '/images/warehouse.jpg',
      '/images/warehouse_2.jpg',
      '/images/airbnb/Outdoor.jpg'
    ]
  }
];